var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-cascader',{staticClass:"title_text_input_class",attrs:{"options":_vm.options,"placeholder":_vm.placeholderValue},on:{"change":_vm.selectOnChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }